import { useHarTransmitterMapQuery } from '@kinetic-ui/data-layer';
import {
  DEFAULT_ZOOM,
  getNodes,
  MapContext,
  MapSearchResultItem,
  useKineticMap,
  useMapBoxSearchContext,
  useMapSearchBoxPin,
} from '@kinetic-ui/shared';
import { Radio } from '@mui/icons-material';
import bbox from '@turf/bbox';
import { BBox2d } from '@turf/helpers/dist/js/lib/geojson';
import { useCallback, useContext, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { ENTITY_DRAWER_VIEW_ALL_ROUTE } from '../EntityList/const';

const MapSearchResult = () => {
  const { selectedLayers, setSelectedLayers, hasEntityDrawer } = useContext(MapContext);
  const { addMapPin, removeMapPin } = useMapSearchBoxPin();
  const { searchText } = useMapBoxSearchContext();
  const { push } = useHistory();
  const map = useKineticMap();

  const { data } = useHarTransmitterMapQuery({
    variables: { searchText, limit: 5 },
    fetchPolicy: 'cache-and-network',
  });

  const onClick = useCallback(
    (id: string, geometry?: any) => {
      if (!hasEntityDrawer) {
        addMapPin(geometry);
        return;
      }
      !selectedLayers.includes('harTransmitters') &&
        setSelectedLayers([...selectedLayers, 'harTransmitters']);
      push(`/${ENTITY_DRAWER_VIEW_ALL_ROUTE}/${id}`);
      const bounds = (geometry ? bbox(geometry) : [0, 0, 0, 0]) as BBox2d;
      map.fitBounds([
        [bounds[0], bounds[1]],
        [bounds[2], bounds[3]],
      ]);
      map.setZoom(DEFAULT_ZOOM);
    },
    [addMapPin, hasEntityDrawer, map, push, selectedLayers, setSelectedLayers]
  );

  useEffect(() => {
    !hasEntityDrawer && searchText?.length > 0 && removeMapPin();
    // only do this when searchText changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchText]);

  const transmitters = getNodes(data?.harTransmitters) ?? [];

  return (
    <>
      {transmitters.map(({ id, name, location }) => (
        <MapSearchResultItem
          icon={<Radio />}
          onClick={() => onClick(id, location)}
          key={`searchItem_${id}`}
          name={name}
        />
      ))}
    </>
  );
};

export default MapSearchResult;
